module.exports = __webpack_public_path__ + "static/media/20180522-LCS-011-1.219169e9.jpg";